export const ALARMS_HISTORY_QUERY_PARAMS = {
  FROM: 'from',
  PHONE_NUMBER: 'phoneNumber',
  ROUTE: 'route',
  TO: 'to',
  TYPE: 'type',
  USER_STARTED: 'userStarted',
  USER_STOPPED: 'userStopped',
};

export const ALARMS_HISTORY_FILTERS = {
  [ALARMS_HISTORY_QUERY_PARAMS.FROM]: {
    field: 'alarm.openedAt',
    operator: 'GTE',
    type: 'dateFilter',
  },
  [ALARMS_HISTORY_QUERY_PARAMS.PHONE_NUMBER]: {
    field: 'alarm.opener.mobilePhone',
    operator: 'REGEX',
    type: 'filter',
  },
  [ALARMS_HISTORY_QUERY_PARAMS.ROUTE]: {
    field: 'alarm.routeNumber',
    operator: 'REGEX',
    type: 'filter',
  },
  [ALARMS_HISTORY_QUERY_PARAMS.TO]: {
    field: 'alarm.openedAt',
    operator: 'LTE',
    type: 'dateFilter',
  },
  [ALARMS_HISTORY_QUERY_PARAMS.TYPE]: {
    field: 'alarm.type',
    operator: 'EQ',
    type: 'filter',
  },
  [ALARMS_HISTORY_QUERY_PARAMS.USER_STARTED]: {
    field: 'alarm.opener.fullName',
    operator: 'REGEX',
    type: 'filter',
  },
  [ALARMS_HISTORY_QUERY_PARAMS.USER_STOPPED]: {
    field: 'alarm.closer.fullName',
    operator: 'REGEX',
    type: 'filter',
  },
};

export const ALARMS_PER_PAGE = 10;

export const CALLS_HISTORY_QUERY_PARAMS = {
  ALARM_ID: 'alarmId',
  END_TIME: 'endTime',
  FROM: 'from',
  START_TIME: 'startTime',
  TO: 'to',
};

export const CALLS_HISTORY_FILTERS = {
  [CALLS_HISTORY_QUERY_PARAMS.ALARM_ID]: {
    field: CALLS_HISTORY_QUERY_PARAMS.ALARM_ID,
    operator: 'REGEX',
    type: 'filter',
  },
  [CALLS_HISTORY_QUERY_PARAMS.END_TIME]: {
    field: CALLS_HISTORY_QUERY_PARAMS.START_TIME,
    operator: 'LTE',
    type: 'dateFilter',
  },
  [CALLS_HISTORY_QUERY_PARAMS.FROM]: {
    field: `${CALLS_HISTORY_QUERY_PARAMS.FROM}.fullName`,
    operator: 'REGEX',
    type: 'filter',
  },
  [CALLS_HISTORY_QUERY_PARAMS.START_TIME]: {
    field: CALLS_HISTORY_QUERY_PARAMS.START_TIME,
    operator: 'GTE',
    type: 'dateFilter',
  },
  [CALLS_HISTORY_QUERY_PARAMS.TO]: {
    field: `${CALLS_HISTORY_QUERY_PARAMS.TO}.fullName`,
    operator: 'REGEX',
    type: 'filter',
  },
};

export const CALLS_PER_PAGE = 10;

export const PAGE_FROM_QUERY_PARAMS = {
  key: 'pageFrom',
  fields: {
    ABSENCES: 'absences',
    ALL_USERS: 'allUsers',
  },
};

export default {
  ActiveAlarms: {
    PER_PAGE: ALARMS_PER_PAGE,
    SORT: [
      {
        direction: 'DESC',
        property: 'openedAt',
      },
    ],
  },
  AlarmsHistory: {
    DATE_PARAMS: [ALARMS_HISTORY_QUERY_PARAMS.FROM, ALARMS_HISTORY_QUERY_PARAMS.TO],
    FILTERS: ALARMS_HISTORY_FILTERS,
    PER_PAGE: ALARMS_PER_PAGE,
    SORT: [
      {
        direction: 'DESC',
        property: 'alarm.openedAt',
      },
    ],
    QUERY_PARAMS: ALARMS_HISTORY_QUERY_PARAMS,
  },
  AlarmHistoryFilters: {
    DATE_PARAMS: [ALARMS_HISTORY_QUERY_PARAMS.FROM, ALARMS_HISTORY_QUERY_PARAMS.TO],
    FILTERS: ALARMS_HISTORY_FILTERS,
    PER_PAGE: ALARMS_PER_PAGE,
    SORT: [
      {
        direction: 'DESC',
        property: 'alarm.openedAt',
      },
    ],
    QUERY_PARAMS: ALARMS_HISTORY_QUERY_PARAMS,
  },
  CallsHistory: {
    DATE_PARAMS: [CALLS_HISTORY_QUERY_PARAMS.END_TIME, CALLS_HISTORY_QUERY_PARAMS.START_TIME],
    FILTERS: CALLS_HISTORY_FILTERS,
    PER_PAGE: CALLS_PER_PAGE,
    SORT: [
      {
        direction: 'DESC',
        property: 'startTime',
      },
    ],
    QUERY_PARAMS: CALLS_HISTORY_QUERY_PARAMS,
  },
  CallsHistoryFilter: {
    DATE_PARAMS: [CALLS_HISTORY_QUERY_PARAMS.END_TIME, CALLS_HISTORY_QUERY_PARAMS.START_TIME],
    FILTERS: CALLS_HISTORY_FILTERS,
    PER_PAGE: CALLS_PER_PAGE,
    SORT: [
      {
        direction: 'DESC',
        property: 'startTime',
      },
    ],
    QUERY_PARAMS: CALLS_HISTORY_QUERY_PARAMS,
  },
};
